import { useAuthUser } from '../../index';

export function useQuestionsEnabled(): boolean {
	const { workspace } = useAuthUser();
	// Default to true if questions_enabled is null/undefined to maintain backward compatibility
	// This toggle can be found in Settings > Questions
	return workspace?.questions_enabled ?? true;
}
